import { render } from "./MenuView.vue?vue&type=template&id=61fbab16&scoped=true"
import script from "./MenuView.vue?vue&type=script&lang=js"
export * from "./MenuView.vue?vue&type=script&lang=js"

import "./MenuView.vue?vue&type=style&index=0&id=61fbab16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61fbab16"]])

export default __exports__